export const scoreConstants = {
  SCORE_LOAD: '[Score] Load',
  SCORE_LOAD_SUCCESS: '[Score] Load success',
  SCORE_LOAD_FAILURE: '[Score] Load failure',
  SCORE_RESET: '[Score] Reset',
  SCORE_SAVE: '[Score] Save',
  SCORE_SAVE_SUCCESS: '[Score] Save success',
  SCORE_SAVE_FAILURE: '[Score] Save failure'
}
